import { TRUST } from "./content";

/**
 * The canvas's `Enterprise Trust` screen.
 *
 * A sticky left rail against a right-hand accordion. Open state is a single
 * index rather than a set, and toggling the open row sends it to -1 — so the
 * group can be fully closed, and only ever one row is open at a time. That is
 * the canvas's behaviour, and it is why `openIndex` is a number here and not a
 * Set<number>.
 */

interface TrustProps {
  openIndex: number;
  onToggle: (i: number) => void;
}

export default function Trust({ openIndex, onToggle }: TrustProps) {
  return (
    <section
      id="trust"
      className="site-gutter"
      style={{ paddingTop: 122, paddingBottom: 122, position: "relative", overflow: "clip" }}
    >
      {/* Rail beside the accordion from tablet up; stacked on a phone, with
          the rail static above it (global.css, T101026002). */}
      <div className="home-trust-layout">
        <div data-rv="" className="home-trust-rail">
          <div
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: 11.5,
              letterSpacing: ".16em",
              textTransform: "uppercase",
              color: "var(--link)",
              marginBottom: 18,
            }}
          >
            <span className="dc-mark" aria-hidden="true" /> Enterprise Trust
          </div>
          <h2
            style={{
              margin: "0 0 16px",
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 600,
              fontSize: "clamp(26px, 3vw, 40px)",
              letterSpacing: "-0.02em",
              lineHeight: 1.16,
            }}
          >
            Built for the accounts that ask the hardest questions
          </h2>
          <p
            style={{
              margin: "0 0 22px",
              fontSize: 16,
              color: "rgba(var(--ink-rgb),.66)",
            }}
          >
            Isolation, scoped permissions, and a complete audit trail:
            the answers your security review needs, before it asks.
          </p>
          <a href="#faq" style={{ fontWeight: 600, fontSize: 14.5 }}>
            Read the security brief &rarr;
          </a>
        </div>
        <div
          data-rv=""
          style={{ borderTop: "1px solid rgba(var(--ink-rgb),.2)" }}
        >
          {TRUST.map((t, i) => {
            const open = openIndex === i;
            return (
              <div
                key={t.title}
                style={{ borderBottom: "1px solid rgba(var(--ink-rgb),.2)" }}
              >
                <button
                  type="button"
                  onClick={() => onToggle(i)}
                  aria-expanded={open}
                  className="dc-h-link"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 20,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "22px 4px",
                    fontFamily: "'Manrope', sans-serif",
                    fontSize: 17.5,
                    fontWeight: 600,
                    color: "var(--ink)",
                    textAlign: "left",
                  }}
                >
                  {t.title}
                  <span
                    style={{
                      fontFamily: "'Manrope', sans-serif",
                      fontSize: 18,
                      color: "var(--acc2)",
                      fontWeight: 400,
                    }}
                  >
                    {open ? "−" : "+"}
                  </span>
                </button>
                {open && (
                  <p
                    style={{
                      margin: 0,
                      padding: "0 40px 24px 4px",
                      fontSize: 15,
                      color: "rgba(var(--ink-rgb),.68)",
                    }}
                  >
                    {t.body}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
